import React, { useEffect, useState } from "react";
import Layout from "../../../layout/Layout";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { HiOutlineDocumentCheck } from "react-icons/hi2";
import { BsPersonFillSlash } from "react-icons/bs";
import { fetchRequestSalons } from "../../../redux/adminReducer";
import Loader from "../../../common/loader";
import Modal from "../../../common/modal";
import { IoMdCheckmark } from "react-icons/io";
import { RxCross2 } from "react-icons/rx";
import { IoEyeOutline } from "react-icons/io5";
import { postApi } from "../../../api/axiosInstance";
import { API_PATH } from "../../../api/apiPath";
import { toast } from "react-toastify";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

function SalonRequest() {
  const navigate = useNavigate();
  const { dir, translations } = useSelector((state) => state.language);
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const [isRejectModalOpen, setIsRejectModalOpen] = useState(false);
  const [isVerifyDocModalOpen, setIsVerifyDocModalOpen] = useState(false);
  const [isBlockModalOpen, setIsBlockModalOpen] = useState(false);
  const [rejectionReason, setRejectionReason] = useState("");
  const [selectedSalon, setSelectedSalon] = useState(null);
  const [selectedUserToBlock, setSelectedUserToBlock] = useState(null);
  const dispatch = useDispatch();

  const status = useSelector((state) => state.admin.requestSalons.status);

  const salonsData = useSelector(
    (state) => state.admin.requestSalons?.data?.salons || []
  );
  const totalSalonData = useSelector(
    (state) => state.admin.requestSalons?.data?.totalData || 0
  );
  const [currentPage, setCurrentPage] = useState(1);
  const [filter, setFilter] = useState("all");
  const [loading, setLoading] = useState(false);
  const itemsPerPage = 10;
  useEffect(() => {
    const b = {
      currentPage,
      filter,
    };
    dispatch(fetchRequestSalons(b));
  }, [dispatch, currentPage, filter]);

  useEffect(() => {
    if (status === "idle") {
      const b = {
        currentPage,
        filter,
      };
      dispatch(fetchRequestSalons(b));
    } else if (status === "loading") {
      setLoading(true);
    } else {
      setLoading(false);
    }
  }, [dispatch, status, currentPage, filter]);

  const handleOpenModal = (salon) => {
    setSelectedSalon(salon);
    setIsVerifyDocModalOpen(true);
  };

  const handleRowClick = (salonId) => {
    navigate(`/salon-request/salonrequest-info/${salonId}`);
  };

  const handleOpenBlockModal = (salon) => {
    setSelectedUserToBlock(salon);
    setIsBlockModalOpen(true);
  };

  const IMAGE_API_URL = "https://jeema.co/api/v2/";
  const handlePreview = () => {
    setIsPreviewOpen(true);
  };

  const handleVerify = async (id) => {
    try {
      setLoading(true);
      const res = await postApi(`${API_PATH.ADMIN.VERIFY_SALON}`, { id });
      if (res.status === 201) {
        const b = {
          currentPage,
          filter,
        };
        dispatch(fetchRequestSalons(b));
        toast.success(translations.toaster.salonVerified);
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleRejectSubmit = async (salonId) => {
    try {
      setLoading(true);
      const res = await postApi(`${API_PATH.ADMIN.REJECT_SALON}`, {
        id: salonId,
        reason: rejectionReason,
      });

      if (res.status === 201) {
        const b = {
          currentPage,
          filter,
        };
        dispatch(fetchRequestSalons(b));
        toast.success(translations.toaster.salonRejected);
        setLoading(false);
        setIsRejectModalOpen(false);
        setIsVerifyDocModalOpen(false);
        setIsPreviewOpen(false);
        setRejectionReason("");
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const handleConfirmBlock = async () => {
    if (!selectedUserToBlock) return;
    try {
      setLoading(true);
      const res = await postApi(
        `${API_PATH.ADMIN.BLOCK_UNBLOCK_SALON}/${selectedUserToBlock._id}`,
        ""
      );
      if (res.status === 201) {
        const b = {
          currentPage,
          filter,
        };
        dispatch(fetchRequestSalons(b));
      }
      if (res.data.data.is_blocked === true) {
        toast.success(translations.toaster.salonBlocked);
      } else {
        toast.success(translations.toaster.salonUnblocked);
      }
    } catch (error) {
      console.log(error);
      toast.error(translations.toaster.errorOccured);
    } finally {
      setLoading(false);
      setIsBlockModalOpen(false);
      setSelectedUserToBlock(null);
    }
  };

  const [error, setError] = useState("");
  const handlePageChange = (event) => {
    const selectedPage = Number(event.target.value);

    if (selectedPage > totalPages) {
      setError(`Maximum value must be ${totalPages}`);
      // setCurrentPage(totalPages);
      return;
    }
    setCurrentPage(selectedPage);
    setError("");
  };
  const totalPages = Math.ceil(totalSalonData / itemsPerPage);
  return (
    <>
      <Layout>
        <div className="min-h-screen w-full  px-4 py-4">
          <section className="pt-1 grid grid-cols-2 items-center">
            <h1 className="text-xl font-bold text-white">
              {translations.salon_request.salonRequests}
              <small className="text-2xl font-semibold text-gray-600"> |</small>
              <small className="font-normal text-gray-600">
                {" "}
                {translations.salon_request.salonRequestManagement}
              </small>
            </h1>

            <div className="text-md text-white flex items-center justify-end space-x-1 ">
              <div className="rounded-full bg-[#5A189A] py-2 px-3">
                <Link
                  to="/"
                  className=" text-white  no-underline cursor-pointer"
                >
                  {translations.salon_request.dashboard}
                </Link>
                <span className="mx-1">/</span>
                <span className="text-green-300 ">
                  {translations.salon_request.salonRequests}
                </span>
              </div>
            </div>
          </section>
          <div className="p-4 w-full bg-gray-800 shadow-xl rounded mt-5">
            {loading ? (
              <Loader />
            ) : (
              <>
                <div className="flex items-center justify-between mb-4">
                  <h2 className="text-2xl font-semibold text-white">
                    {translations.salon_request.salonRequestList}
                  </h2>
                  <div className="flex items-center">
                    <label htmlFor="salon-status" className="text-white px-2">
                      {translations.salon_request.filter} :
                    </label>
                    <div className="relative">
                      <select
                        id="salon-status"
                        className="bg-gray-700 text-white rounded ps-2 pe-5 py-2 focus:outline-none w-full appearance-none"
                        value={filter}
                        onChange={(e) => {
                          const value =
                            e.target.value === "all"
                              ? "all"
                              : Number(e.target.value);
                          setFilter(value);
                          setCurrentPage(1);
                        }}
                      >
                        <option value="all">
                          {translations.salon_request.all}
                        </option>
                        <option value="401">
                          {translations.salon_request.unverfied}
                        </option>
                        <option value="403">
                          {translations.salon_request.rejected}
                        </option>
                      </select>

                      <div className="absolute inset-y-0 right-0 flex items-center px-3 pointer-events-none">
                        <svg
                          className="w-4 h-4 text-white"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M19 9l-7 7-7-7"
                          ></path>
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
                {salonsData.length === 0 ? (
                  <div className="flex h-64 items-center justify-center text-gray-500 dark:text-gray-400">
                    <p className="text-xl">
                      {translations.salon_request.noData}
                    </p>
                  </div>
                ) : (
                  <>
                    <div className="grid  md:grid lg:grid  overflow-x-auto ">
                      <table className="min-w-full text-white shadow-md text-center  p-2">
                        <thead className="bg-[#5A189A] text-white text-md text-center">
                          <tr>
                            <th className=" px-3 py-3 whitespace-nowrap">
                              {translations.salon_request.businessName}
                            </th>
                            <th className=" px-3 py-3 whitespace-nowrap">
                              {translations.salon_request.businessType}
                            </th>
                            <th
                              className=" px-3 py-3 whitespace-nowrap"
                              style={{ direction: "ltr" }}
                            >
                              {translations.salon_request.phoneNumber}
                            </th>
                            <th className=" px-3 py-3 whitespace-nowrap">
                              {translations.salon_request.commercialId}
                            </th>

                            <th className=" px-3 py-3 whitespace-nowrap">
                              {translations.salon_request.contactAt}
                            </th>
                            <th className=" px-3 py-3 whitespace-nowrap">
                              {translations.salon_request.verified}
                            </th>
                            <th className=" px-3 py-3 whitespace-nowrap">
                              {translations.salon_request.status}
                            </th>
                            <th className=" px-3 py-3 whitespace-nowrap">
                              {translations.salon_request.createdAt}
                            </th>
                            <th className=" px-3 py-3 whitespace-nowrap">
                              {translations.salon_request.actions}
                            </th>
                          </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-600 ">
                          {salonsData.map((salon, index) => (
                            <tr
                              key={index}
                              onClick={() => handleRowClick(salon._id)}
                              className={`hover:bg-gray-700 transition cursor-pointer text-center mb-3 ${
                                salon.is_blocked === false
                                  ? "text-white"
                                  : "text-red-500"
                              }`}
                            >
                              <td className="px-3 py-3">
                                {salon.business_name}
                              </td>
                              <td className="px-3 py-3">
                                {salon.business_type === 0
                                  ? translations.salon_request.individual
                                  : translations.salon_request.commercial}
                              </td>
                              <td
                                className="px-3 py-3"
                                style={{ direction: "ltr" }}
                              >
                                {salon.business_phone}
                              </td>
                              <td className="px-3 py-3">
                                {salon.commercial_id}
                              </td>

                              <td className="px-3 py-3  whitespace-nowrap">
                                {salon.email}
                              </td>
                              <td className="px-3 py-3">
                                <button
                                  onClick={(e) => {
                                    e.stopPropagation(); //  prevent navigating to salon-info
                                    handleOpenModal(salon);
                                  }}
                                  disabled={salon.is_blocked === true}
                                  title={`${
                                    salon.registration_rejected_reason
                                      ?.length === 0
                                      ? translations.salon_request
                                          .verificationPending
                                      : translations.salon_request
                                          .documentRejected
                                  }`}
                                  className="text-amber-400 text-2xl px-3 py-1 rounded"
                                >
                                  <HiOutlineDocumentCheck />
                                </button>
                              </td>
                              <td className="px-4 py-3 font-semibold ">
                                <p
                                  className={`rounded-full px-3.5 mt-3 text-body-sm font-medium capitalize ${
                                    salon.is_blocked
                                      ? "bg-[#D34053]/[0.08] text-[#D34053]"
                                      : salon.status === 401
                                      ? "bg-[#FFA70B]/[0.08] text-[#FFA70B]"
                                      : "bg-[#D34053]/[0.08] text-[#D34053]"
                                  }`}
                                >
                                  {salon.is_blocked === true
                                    ? translations.salon_request.blocked
                                    : salon.status === 401
                                    ? translations.salon_request.unverfied
                                    : translations.salon_request.rejected}
                                </p>
                              </td>
                              <td className="px-4 py-3">
                                {new Date(salon.createdAt).toLocaleDateString()}
                              </td>
                              <td className="px-4 py-3 flex ">
                                <button
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleOpenBlockModal(salon);
                                  }}
                                  className={`px-2 pt-3 text-2xl ${
                                    salon.is_blocked === false
                                      ? "hover:text-red-500"
                                      : "hover:text-green-600"
                                  }`}
                                >
                                  <BsPersonFillSlash />
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                    {/* Pagination Controls */}
                    <div className="mt-4 flex justify-between text-white">
                      <svg
                        className={`${
                          currentPage === 1
                            ? "fill-current"
                            : "cursor-pointer fill-current"
                        }
                        ${dir === "rtl" && "rotate-180"}`}
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 320 512"
                        width={24}
                        height={24}
                        onClick={() =>
                          setCurrentPage((prev) => Math.max(prev - 1, 1))
                        }
                        aria-disabled={currentPage === 1}
                      >
                        <path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z" />
                      </svg>
                      <span>
                        {translations.salon_request.page}
                        {totalPages > 1 ? (
                          <input
                            type="number"
                            name=""
                            id="pagination-jump"
                            className={
                              error
                                ? `mx-2 rounded-md border  ps-1 border-red  bg-gray-800 text-white shadow-card focus:border-primary`
                                : `mx-2 rounded-md border border-gray-300 ps-1  bg-gray-800 text-white shadow-card focus:border-primary`
                            }
                            min={1}
                            max={totalPages}
                            defaultValue={currentPage}
                            onChange={(e) => e.target.value}
                            onBlur={(e) => handlePageChange(e)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                handlePageChange(e);
                              }
                            }}
                          />
                        ) : (
                          <span className="mx-1">{currentPage}</span>
                        )}
                        {translations.salon_request.of} {totalPages}
                      </span>
                      <svg
                        className={`${
                          currentPage === totalPages
                            ? "fill-current"
                            : "cursor-pointer fill-current"
                        }
                        ${dir === "rtl" && "rotate-180"}`}
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 320 512"
                        onClick={() =>
                          setCurrentPage((prev) =>
                            Math.min(prev + 1, totalPages)
                          )
                        }
                        aria-disabled={currentPage === totalPages}
                      >
                        <path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z" />
                      </svg>
                    </div>
                  </>
                )}
              </>
            )}
          </div>
        </div>
      </Layout>
      {/* Document Modal */}
      <Modal
        isOpen={isVerifyDocModalOpen}
        onClose={() => setIsVerifyDocModalOpen(false)}
        width="w-[90%] md:w-[600px]"
      >
        {selectedSalon && (
          <>
            <div className="flex justify-between mt-4">
              <h2 className="text-xl font-bold mb-4 text-gray-300">
                {translations.salon_verification.documentReview}
              </h2>

              <div className="flex items-center justify-end mb-4 gap-4">
                <span className="flex items-center gap-1">
                  <span className="h-2 w-2 rounded-full bg-red-500"></span>
                  <span className="text-sm text-gray-300">
                    {translations.salon_verification.rejected}
                  </span>
                </span>
                <span className="flex items-center gap-1">
                  <span className="h-2 w-2 rounded-full bg-gray-400"></span>
                  <span className="text-sm text-gray-300">
                    {translations.salon_verification.pending}
                  </span>
                </span>
              </div>
            </div>

            <div className="overflow-x-auto">
              <table className="min-w-full text-gray-400">
                <thead>
                  <tr className="text-center">
                    <th className="py-2">
                      {translations.salon_verification.registrationNumber}
                    </th>
                    <th className="px-4 py-2">
                      {translations.salon_verification.status}
                    </th>
                    <th className="px-4 py-2">
                      {translations.salon_verification.preview}
                    </th>
                    {selectedSalon.status === 401 && (
                      <th className="px-4 py-2">
                        {translations.salon_verification.actions}
                      </th>
                    )}
                  </tr>
                </thead>
                <tbody className="text-center">
                  <tr className="">
                    <td className="px-2 py-4">
                      {selectedSalon.registration_number}
                    </td>
                    <td
                      className={`px-4 py-2 text-center ${
                        selectedSalon.status === 403
                          ? "text-red-600"
                          : selectedSalon.status === 401
                          ? "text-gray-400"
                          : "text-green-600"
                      }`}
                    >
                      {selectedSalon.status === 401
                        ? "Pending"
                        : selectedSalon.status === 402
                        ? "Verified"
                        : "Rejected"}
                    </td>
                    <td className="px-4 py-4">
                      <button
                        onClick={() => handlePreview()}
                        className="text-white bg-gray-600 p-2 rounded-full hover:bg-gray-500"
                      >
                        <IoEyeOutline />
                      </button>
                    </td>
                    {selectedSalon.status === 401 && (
                      <td className="px-4 py-4">
                        <button
                          className="p-2 mx-2 rounded-full bg-red-600 hover:bg-red-700 text-white"
                          onClick={(e) => {
                            e.stopPropagation();
                            setIsRejectModalOpen(true);
                          }}
                        >
                          <RxCross2 />
                        </button>
                        <button
                          className="p-2 mx-2 rounded-full bg-green-600 hover:bg-green-700 text-white"
                          onClick={() => {
                            handleVerify(selectedSalon._id);
                            setIsVerifyDocModalOpen(false);
                          }}
                        >
                          <IoMdCheckmark />
                        </button>
                      </td>
                    )}
                  </tr>
                </tbody>
              </table>
            </div>
          </>
        )}
      </Modal>

      {/* document preview modal */}
      <Modal
        isOpen={isPreviewOpen}
        onClose={() => setIsPreviewOpen(false)}
        width="w-[90%] md:w-[600px]"
      >
        {isPreviewOpen && (
          <div className="mx-auto rounded-lg relative w-[90%] max-w-2xl text-white">
            <h2 className="text-xl font-bold mb-4">
              {translations.salon_verification.documentPreview}
            </h2>
            <div className="bg-gray-800 rounded-lg p-6 space-y-4">
              {(selectedSalon?.registration_document || []).map(
                (doc, index) => {
                  const fullUrl = `${IMAGE_API_URL}${encodeURIComponent(doc)}`;
                  const isPdf = /\.pdf$/i.test(doc);

                  return isPdf ? (
                    <button
                      key={index}
                      onClick={() => window.open(fullUrl, "_blank")}
                      className="w-full text-left bg-white/10 hover:bg-white/20 transition text-white px-4 py-3 rounded flex items-center gap-2"
                    >
                      📄 View Document {index + 1}
                    </button>
                  ) : (
                    <img
                      key={index}
                      src={fullUrl}
                      alt={`Document ${index + 1}`}
                      className="w-full max-w-[500px] h-auto object-contain mx-auto rounded"
                    />
                  );
                }
              )}
            </div>
            <div className="pt-4 flex justify-end space-x-2">
              {selectedSalon?.status === 403 && (
                <div className="text-red-500 text-right">
                  <div className="flex items-center justify-end mb-1">
                    <span className="mr-2">
                      {translations.salon_verification.rejected}
                    </span>
                    <RxCross2 />
                  </div>
                  {selectedSalon?.registration_rejected_reason && (
                    <div className="text-gray-400 text-sm">
                      {translations.salon_verification.reason}:{" "}
                      {selectedSalon?.registration_rejected_reason}
                    </div>
                  )}
                </div>
              )}

              {selectedSalon?.status === 401 && (
                <>
                  <button
                    className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600"
                    onClick={(e) => {
                      e.stopPropagation();
                      setIsRejectModalOpen(true);
                    }}
                  >
                    <span className="flex items-center">
                      <RxCross2 className="mr-2" />
                      {translations.salon_verification.reject}
                    </span>
                  </button>
                  <button
                    className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600"
                    onClick={() => {
                      handleVerify(selectedSalon._id);
                      setIsVerifyDocModalOpen(false);
                      setIsPreviewOpen(false);
                    }}
                  >
                    <span className="flex items-center">
                      <IoMdCheckmark className="mr-2" />
                      {translations.salon_verification.accept}
                    </span>
                  </button>
                </>
              )}
            </div>
          </div>
        )}
      </Modal>

      {/* Document Rejection Modal */}
      <Modal
        isOpen={isRejectModalOpen}
        onClose={() => setIsRejectModalOpen(false)}
        width="w-[90%] md:w-[500px]"
      >
        {selectedSalon && (
          <div className="text-white p-6 bg-gray-800 rounded-lg">
            <h2 className="mb-4 text-xl font-semibold">
              {translations.salon_request.reject_Document}
            </h2>
            <div className="mb-4">
              <label className="block text-gray-300 mb-2">
                {translations.salon_request.enterReason}:
              </label>
              <textarea
                value={rejectionReason}
                rows={5}
                onChange={(e) => setRejectionReason(e.target.value)}
                placeholder={translations.salon_request.enterReason}
                className="w-full rounded-md border-[1.5px] border-dark-3 bg-gray-700 text-white px-4 py-2.5 focus:border-primary focus-visible:outline-none resize-none"
              />
            </div>
            <div className="flex justify-end gap-3 mt-6">
              <button
                onClick={() => setIsRejectModalOpen(false)}
                className="px-4 py-2 rounded bg-gray-600 text-white hover:bg-gray-500"
              >
                {translations.salon_request.cancel}
              </button>
              <button
                onClick={() => handleRejectSubmit(selectedSalon._id)}
                disabled={!rejectionReason.trim()}
                className="px-4 py-2 rounded bg-red-600 text-white hover:bg-red-700 disabled:cursor-not-allowed disabled:opacity-50"
              >
                {translations.salon_request.submitRejection}
              </button>
            </div>
          </div>
        )}
      </Modal>

      {/* Block Salon Modal */}
      <Modal
        isOpen={isBlockModalOpen}
        onClose={() => setIsBlockModalOpen(false)}
        width="w-[90%] max-w-md"
      >
        <div className="p-2 text-white">
          <h2 className="mb-4 text-xl font-bold">
            {selectedUserToBlock?.is_blocked
              ? translations.salon_request.unblock
              : translations.salon_request.block}{" "}
            {translations.salon_request.salon}
          </h2>
          <p className="mb-6">
            {translations.salon_request.warning}{" "}
            {selectedUserToBlock?.is_blocked
              ? translations.salon_request.unblock
              : translations.salon_request.block}{" "}
            <strong>{selectedUserToBlock?.business_name}</strong>?
          </p>
          <div className="flex justify-end space-x-4">
            <button
              onClick={() => setIsBlockModalOpen(false)}
              className="px-4 py-2 rounded bg-gray-400 text-white hover:bg-gray-500"
            >
              {translations.salon_request.cancel}
            </button>
            <button
              onClick={handleConfirmBlock}
              className={`px-4 py-2 rounded text-white ${
                selectedUserToBlock?.is_blocked
                  ? "bg-green-600 hover:bg-green-700"
                  : "bg-red-600 hover:bg-red-700"
              }`}
            >
              {selectedUserToBlock?.is_blocked
                ? translations.salon_request.unblock
                : translations.salon_request.block}{" "}
              {translations.salon_request.salon}
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
}

export default SalonRequest;
